import { limitOrderApiConnector } from 'apiConnector/secondary-market/limit-order/order';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { limitOrderCancellationActions } from 'state/secondaryMarket/limit-order/cancellation/cancellations.actions';
import { limitOrderCancellationThunks } from 'state/secondaryMarket/limit-order/cancellation/cancellations.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

export function cancelLimitOrderTradeEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_CANCELLATION_REQUESTED'),
      mergeMap(({ orderId }) => {
        return limitOrderApiConnector(httpClient)
          .cancelOrder(orderId)
          .pipe(
            map(response => limitOrderCancellationActions.secondaryMarketCancelReceived(orderId, response)),
            catchError((error: HttpError) => {
              frontLogger.error('An error occurred inside cancelLimitOrderTradeEpic {@FrontError}', error);
              return of(limitOrderCancellationThunks.orderCancellationErrorsThunk(orderId, error));
            }),
          );
      }),
    );
}
